import { http } from '@/http/index'

async function sendComplaint(consumerId) {
	return http.post(`/consumers/${consumerId}/complaints`)
}

export { sendComplaint }
